import { Box, HStack, Text } from "@chakra-ui/react";
import { INHERITANCE_STATE } from "../models/scoringModel";

/**
 * Renders the 3 inheritance states from the recruitment-form side of the
 * spec. Purely presentational -- the host owns the actual override mutation
 * via `onCustomizeForRecruitment`.
 */
const InheritanceBadge = ({ state, onCustomizeForRecruitment, labels }) => {
    if (state === INHERITANCE_STATE.LOCAL) return null;

    if (state === INHERITANCE_STATE.LOCKED) {
        return (
            <Box borderRadius={6} border="1px solid" borderColor="gray.200" bg="gray.50" px={3} py={2}>
                <Text fontSize="xs" color="gray.700" fontWeight={600}>{labels.sourceScenario}</Text>
                <Text fontSize="xs" color="gray.500">{labels.sourceScenarioLocked}</Text>
            </Box>
        );
    }

    if (state === INHERITANCE_STATE.OVERRIDABLE) {
        return (
            <HStack justify="space-between" borderRadius={6} border="1px solid" borderColor="gray.200" bg="gray.50" px={3} py={2}>
                <Text fontSize="xs" color="gray.700" fontWeight={600}>{labels.sourceScenario}</Text>
                <Box
                    as="button"
                    type="button"
                    onClick={onCustomizeForRecruitment}
                    px={2.5}
                    py={1}
                    borderRadius={6}
                    fontSize="xs"
                    color="purple.600"
                    border="1px solid"
                    borderColor="purple.300"
                    _hover={{ bg: "purple.50" }}
                >
                    {labels.customizeForRecruitment}
                </Box>
            </HStack>
        );
    }

    if (state === INHERITANCE_STATE.OVERRIDDEN) {
        return (
            <Box borderRadius={6} border="1px solid" borderColor="purple.300" bg="purple.50" px={3} py={2}>
                <Text fontSize="xs" color="purple.700" fontWeight={600}>{labels.sourceRecruitment}</Text>
            </Box>
        );
    }

    return null;
};

export default InheritanceBadge;
